import { render } from "./Sitemap.vue?vue&type=template&id=648e9525&scoped=true"
import script from "./Sitemap.vue?vue&type=script&lang=js"
export * from "./Sitemap.vue?vue&type=script&lang=js"

import "./Sitemap.vue?vue&type=style&index=0&id=648e9525&lang=css"
import "./Sitemap.vue?vue&type=style&index=1&id=648e9525&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648e9525"]])

export default __exports__